import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Preload hero image to reduce LCP resource load delay
const preloadLink = document.createElement('link');
preloadLink.rel = 'preload';
preloadLink.as = 'image';
preloadLink.href = 'https://cdn.magicpatterns.com/uploads/baUxQRRPJNXGcYGntg8m1H/heylloyd-image-1773076189036.jpg';
preloadLink.type = 'image/jpeg';
preloadLink.setAttribute('fetchpriority', 'high');
preloadLink.setAttribute('imagesizes', '(max-width: 768px) 100vw, (max-width: 1024px) 80vw, 896px');
document.head.appendChild(preloadLink);
// ── Meta Pixel (runs ONCE, outside React) ──
const META_PIXEL_ID = '1537431667546082';
const initPixel = () => {
  if ((window as any).fbq) return;
  const n: any = (window as any).fbq = function (...args: any[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
  };
  if (!(window as any)._fbq) (window as any)._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  if (!document.querySelector('script[src*="fbevents.js"]')) {
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(t);
  }
  ;
  (window as any).fbq('init', META_PIXEL_ID);
  (window as any).fbq('track', 'PageView');
};
if ('requestIdleCallback' in window) {
  ;
  (window as any).requestIdleCallback(initPixel);
} else {
  setTimeout(initPixel, 2500);
}
render(<App data-id="element-310" />, document.getElementById('root'));